import { periodDates, periodNumberFor, periodRangeLabel } from '../../lib/payPeriods'

/**
 * The current pay period: whichever real 14-day period (src/lib/payPeriods.ts)
 * contains today, generated from the real clock rather than fixed to one
 * hardcoded calendar window, so every screen that names it keeps naming a
 * period that actually contains today. Only the calendar itself lives here:
 * what a person works on those days is read from the database.
 */
const now = new Date()
const REAL_TODAY_ISO = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`
const CURRENT_PERIOD_NUMBER = periodNumberFor(REAL_TODAY_ISO)

export const PAY_PERIOD = {
  label: `Pay Period ${CURRENT_PERIOD_NUMBER}`,
  range: periodRangeLabel(CURRENT_PERIOD_NUMBER),
}

export const PAY_PERIOD_DATES = periodDates(CURRENT_PERIOD_NUMBER)
